import { Button, Pagination } from "flowbite-react";
import React from "react";
import { Link } from "react-router-dom";

const QueryReTable = ({
  headingNeed,
  heading,
  buttonNeed,
  buttonText,
  children,
  setSearchValues,
  searchValues,
  moreData,
  totalData,
  buttonNavigation,
}) => {
  const onPageChange = (page) => {
    setSearchValues((prev) => ({ ...prev, page })); // Update search values with new page
  };

  const LIMIT = 10;
  const PAGE = parseInt(searchValues.page) ?? 1;
  const OFFSET = (PAGE - 1) * LIMIT;

  return (
    <div className="flex flex-col gap-y-6">
      {headingNeed && (
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-gray-700">{heading}</h2>
          {buttonNeed && (
            <Link
              to={buttonNavigation ? buttonNavigation : "/purchase-order/new"}
            >
              <Button>
                {buttonText ? buttonText : "Create Request Order"}
              </Button>
            </Link>
          )}
        </div>
      )}
      <div className="flex flex-col gap-y-4">
        <div className="flex overflow-x-auto flex-col-reverse">
          <Pagination
            layout="navigation"
            currentPage={Number(searchValues?.page ?? 0)}
            totalPages={searchValues.page + (moreData ? 1 : 0)} // Adjust this based on your API response
            onPageChange={onPageChange}
          />

          <div>
            <p>
              Showing <span className="font-bold">{OFFSET + 1}</span> to{" "}
              <span className="font-bold">
                {totalData
                  ? totalData < PAGE * LIMIT
                    ? totalData
                    : PAGE * LIMIT
                  : "..."}
              </span>{" "}
              of{" "}
              <span className="font-bold">{totalData ? totalData : "..."}</span>{" "}
              Entries
            </p>
          </div>
        </div>
        <div className="">{children}</div>
      </div>
    </div>
  );
};

export default QueryReTable;
